import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { ReportsPage } from './ReportsPage';

/**
 * Einstiegspunkt des Moduls Auswertungen im Backoffice (KON-169, Schlüssel `reports`, siehe docs/auswertungen.md): Kennzahlen mit Jahresvergleich unter /auswertungen.
 */
export const reportsModule: BackofficeModule = {
  key: 'reports',
  path: '/auswertungen',
  routes: <Route path="auswertungen" element={<ModuleGate module="reports" permission="reports.read"><ReportsPage /></ModuleGate>} />,
};
